<template>
  <div>
    <alerts-list />
    <span v-if="this.$store.getters.hasInvoiceAccess">
      <page-header
        :title="pageTitle"
        :commands="[{ to: '/newinvoice/create/new/', icon: '+', text: 'New invoice' }]"
      />
      <h3 class="center p-15" v-if="!dataLoaded">Loading data...</h3>
      <h3 class="center p-15" v-if="dataLoaded && invoiceList.length < 1">
        No invoices to display
      </h3>
      <Invoice
        v-for="invoice in invoiceList"
        :key="invoice.invoiceNumber"
        :info="invoice"
      />
      <div class='center p-15' v-if="dataLoaded && invoiceList.length > 0 && !hasLoadedMaxAmount">
        <button class='green p-10' @click="loadMoreInvoices">Load more</button>
      </div>
    </span>
    <span v-else>
      <div class="container between row pt-10 center">
        <h1>Welcome</h1>
      </div>
    </span>
  </div>
</template>

<script>
import Invoice from "../../components/Invoice";
import AlertsList from '../../components/AlertsList'
import PageHeader from '../../components/PageHeader.vue';
export default {
  name: "dashboard-route",
  components: { Invoice, AlertsList, PageHeader },
  data: () => ({
    hasLoadedMaxAmount: false
  }),
  methods: {
    async loadMoreInvoices () {
      const prevLoaded = this.$store.getters.invoiceList.length
      await this.$store.dispatch("loadMoreInvoices")
      if(prevLoaded === this.$store.getters.invoiceList.length) {
        this.hasLoadedMaxAmount = true
      }
    }
  },
  computed: {
    totalLoaded() {
      return this.$store.getters.invoiceList.length
    },
    dataLoaded(){
      return this.$store.getters.dataLoaded
    },
    invoiceList() {
      return [...this.$store.getters.invoiceList].splice(0, this.$store.getters.page * 10);
    },
    pageTitle(){
      return this.$route.params.filter || 'Recent jobs'
    }
  }
};
</script>

